import localStorage from 'localStorage'
import jwt from 'jsonwebtoken';
import store from "../reduxs/store";

class Auth {
  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  static authenticateUser (token) {
    localStorage.setItem('token', token)
  }

  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @returns {boolean}
   */
  static isUserAuthenticated () {
    return (localStorage.getItem('token') !== null)
  }

  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   *
   */
  static deauthenticateUser () {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('store')
  }

  /**
   * Get a token value.
   *
   * @returns {string}
   */

  static getToken () {
    const oidc = store.getState().oidc;
    if(oidc && oidc.user && oidc.user.access_token) {
      return oidc.user.access_token;
    }
    return localStorage.getItem('token');
  }

  /**
   * Set userinfo. Save userinfo in Local Storage
   *
   * @param {string} user
   */
  static setUserInfo (user) {
    localStorage.setItem('userInfo', user)
  }

  /**
   * Get userinfo.
   *
   * @returns {string}
   */

  static getUserInfo () {
    return localStorage.getItem('userInfo')
  }

  /**
   *Set station.
   *
   * @returns {string}
   */

  static setStation (station) {
      localStorage.setItem('station', station);
  }

  /**
   * Get station.
   *
   * @returns {string}
   */

  static getStation () {
    return localStorage.getItem('station');
  }

  static getUser () {
    try {
      const token = this.getToken();
      var user = jwt.decode(token);
      if(user) {
        return user;
      } 
      return {};
    } catch (error) {
      return {};
    }
  }
}

export default Auth
